export function AnimatedBackdrop() {
	return (
		<div className="backdrop" aria-hidden="true">
			<div className="backdrop__stars backdrop__stars--near" />
			<div className="backdrop__stars backdrop__stars--far" />
			<div className="backdrop__scanline" />
		</div>
	);
}
